export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-movie-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line' },
];

export const subcategories: Record<string, { slug: string; name: string }[]> = {
  movie: [
    { slug: 'action', name: '动作片' },
    { slug: 'comedy', name: '喜剧片' },
    { slug: 'drama', name: '剧情片' },
    { slug: 'scifi', name: '科幻片' },
    { slug: 'horror', name: '恐怖片' },
    { slug: 'romance', name: '爱情片' },
    { slug: 'animation', name: '动画片' },
    { slug: 'thriller', name: '悬疑片' },
  ],
  tv: [
    { slug: 'domestic', name: '国产剧' },
    { slug: 'korean', name: '韩剧' },
    { slug: 'american', name: '美剧' },
    { slug: 'japanese', name: '日剧' },
    { slug: 'costume', name: '古装剧' },
    { slug: 'modern', name: '现代剧' },
  ],
  variety: [
    { slug: 'talk', name: '脱口秀' },
    { slug: 'reality', name: '真人秀' },
    { slug: 'music', name: '音乐综艺' },
    { slug: 'game', name: '游戏竞技' },
    { slug: 'dating', name: '恋爱综艺' },
  ],
  anime: [
    { slug: 'chinese', name: '国漫' },
    { slug: 'japanese_anime', name: '日漫' },
    { slug: 'movie_anime', name: '动画电影' },
    { slug: 'series', name: '连载动画' },
  ],
};

export interface MovieItem {
  id: number;
  title: string;
  category: string;
  subcategory: string;
  year: number;
  rating: number;
  description: string;
  image: string;
  tags: string[];
  director: string;
  cast: string[];
  episodes: number;
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
}

export const movies: MovieItem[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    subcategory: 'scifi',
    year: 2026,
    rating: 9.2,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对浩瀚宇宙的未知旅程，一群勇敢的年轻人挺身而出，为拯救人类文明而战。这部震撼人心的科幻巨制延续了前作的宏大世界观，视觉效果再次突破想象边界，讲述了一个关于希望、牺牲与团结的动人故事。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20astronauts%20in%20space%20suits%20looking%20at%20a%20giant%20planet%2C%20dramatic%20cinematic%20lighting%2C%20dark%20deep%20space%20background%20with%20stars%2C%20film%20poster%20aesthetic%2C%20high%20contrast%2C%20professional%20movie%20marketing%20visual&width=600&height=900&seq=movie-poster-001&orientation=portrait',
    tags: ['科幻', '灾难', '冒险', 'IMAX'],
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '王智'],
    episodes: 1,
    updateInfo: '2026年春节档热映',
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '长安十二时辰',
    category: 'tv',
    subcategory: 'costume',
    year: 2025,
    rating: 8.9,
    description: '唐朝天宝三年，上元节前夕，长安城混入可疑人员。死囚张小敬临危受命，与少年名士李必携手在十二时辰内破除隐患，拯救长安城于危难之中。精良的制作还原了大唐盛世的恢弘气象，紧凑的剧情设计让每一集都扣人心弦。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20drama%20poster%20with%20warriors%20in%20traditional%20armor%20standing%20on%20city%20wall%2C%20lantern-lit%20ancient%20city%20at%20night%2C%20dramatic%20cinematic%20composition%2C%20film%20poster%20style%2C%20warm%20golden%20and%20dark%20tones&width=600&height=900&seq=tv-poster-001&orientation=portrait',
    tags: ['古装', '悬疑', '历史', '精品剧'],
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    episodes: 48,
    updateInfo: '已完结 · 共48集',
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '极限挑战 第十季',
    category: 'variety',
    subcategory: 'reality',
    year: 2026,
    rating: 8.5,
    description: '国民综艺《极限挑战》第十季重磅回归！全新阵容带来更多意想不到的挑战任务，笑料与温情并存。六位成员将穿越中国大好河山，在极限环境中展现真实的友情与勇气，为观众带来欢乐与感动。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20six%20celebrities%20laughing%20and%20posing%20dynamically%2C%20colorful%20vibrant%20background%20with%20outdoor%20adventure%20theme%2C%20playful%20energetic%20composition%2C%20TV%20show%20promotional%20poster%20style&width=600&height=900&seq=variety-poster-001&orientation=portrait',
    tags: ['真人秀', '搞笑', '户外', '热门'],
    director: '严敏',
    cast: ['黄渤', '孙红雷', '黄磊', '罗志祥', '张艺兴', '王迅'],
    episodes: 12,
    updateInfo: '更新至第8期',
    isHot: true,
    isNew: true,
  },
  {
    id: 4,
    title: '深海',
    category: 'anime',
    subcategory: 'movie_anime',
    year: 2025,
    rating: 8.8,
    description: '一个少女在神秘的海底世界展开奇幻冒险，遇见了各种奇妙的生物。影片以极致唯美的画面和感人至深的故事，探讨了成长、孤独与勇气的主题。历时七年打磨的国漫巅峰之作，每一帧都堪称壁纸级画面。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20a%20young%20girl%20floating%20in%20deep%20ocean%20surrounded%20by%20colorful%20jellyfish%20and%20bioluminescent%20creatures%2C%20dreamy%20surreal%20atmosphere%2C%20watercolor%20ink%20style%2C%20beautiful%20ethereal%20lighting&width=600&height=900&seq=anime-poster-001&orientation=portrait',
    tags: ['国漫', '奇幻', '冒险', '催泪'],
    director: '田晓鹏',
    cast: ['苏鑫', '王亭文'],
    episodes: 1,
    updateInfo: '2025年暑期档上映',
    isHot: false,
    isNew: false,
  },
  {
    id: 5,
    title: '狂飙',
    category: 'tv',
    subcategory: 'domestic',
    year: 2025,
    rating: 9.3,
    description: '一部横跨二十年的扫黑大剧，讲述了警察安欣与黑恶势力长达二十年的生死较量。从一名普通刑警到扫黑除恶的坚定战士，安欣用青春和热血守护一方平安。剧情层层递进，人物刻画入木三分，被誉为近年国产剧的标杆之作。',
    image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%20with%20a%20serious%20police%20detective%20in%20dark%20suit%20standing%20in%20shadow%2C%20urban%20night%20cityscape%20background%2C%20gritty%20realistic%20tone%2C%20film%20noir%20inspired%20lighting%2C%20Chinese%20TV%20drama%20poster%20style&width=600&height=900&seq=tv-poster-002&orientation=portrait',
    tags: ['刑侦', '扫黑', '悬疑', '高分'],
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    episodes: 39,
    updateInfo: '已完结 · 共39集',
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: '满江红',
    category: 'movie',
    subcategory: 'drama',
    year: 2025,
    rating: 8.7,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一群义士为揭露真相，在宰相府邸上演了一场惊心动魄的局中局。张艺谋导演以其独特的视觉美学，打造了一部兼具商业性与艺术性的古装悬疑大片。',
    image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20movie%20poster%20set%20in%20Song%20dynasty%2C%20soldiers%20in%20ancient%20Chinese%20armor%20marching%20through%20narrow%20alley%2C%20dark%20moody%20atmosphere%20with%20red%20lanterns%2C%20dramatic%20shadow%20play%2C%20cinematic%20composition&width=600&height=900&seq=movie-poster-002&orientation=portrait',
    tags: ['古装', '悬疑', '喜剧', '剧情'],
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    episodes: 1,
    updateInfo: '2025年春节档上映',
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    title: '乘风破浪的姐姐 第五季',
    category: 'variety',
    subcategory: 'music',
    year: 2026,
    rating: 8.3,
    description: '30位30+的姐姐再次集结，用实力证明年龄只是数字。她们在舞台上挥洒汗水、突破自我，展现成熟女性的魅力与力量。本季加入更多原创音乐元素，姐姐们的舞台表现力全面升级，每一场公演都堪称视听盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20with%20elegant%20women%20in%20stunning%20gowns%20on%20a%20glittering%20stage%2C%20spotlights%20and%20stage%20effects%2C%20glamorous%20entertainment%20vibe%2C%20TV%20show%20promotional%20poster%20style%2C%20golden%20and%20purple%20lighting&width=600&height=900&seq=variety-poster-002&orientation=portrait',
    tags: ['音乐', '竞技', '女性', '热门综艺'],
    director: '吴梦知',
    cast: ['宁静', '那英', '张雨绮', '万茜', '蓝盈莹'],
    episodes: 12,
    updateInfo: '更新至第6期',
    isHot: true,
    isNew: true,
  },
  {
    id: 8,
    title: '三体',
    category: 'anime',
    subcategory: 'chinese',
    year: 2025,
    rating: 9.0,
    description: '改编自刘慈欣同名科幻小说，讲述了地球人类文明和三体文明的信息交流、生死搏杀及两个文明在宇宙中的兴衰历程。动画版以顶尖的制作水准还原了原著宏大的宇宙观和深刻的哲学思考，是国产科幻动画的里程碑。',
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20anime%20poster%20with%20a%20massive%20alien%20spaceship%20hovering%20above%20Earth%2C%20futuristic%20technology%20and%20holographic%20displays%2C%20dark%20cosmic%20background%20with%20three%20suns%2C%20anime%20art%20style%2C%20cinematic%20composition&width=600&height=900&seq=anime-poster-002&orientation=portrait',
    tags: ['科幻', '国漫', '小说改编', '史诗'],
    director: '林铭浩',
    cast: ['马正阳', '范哲琛', '段艺璇'],
    episodes: 15,
    updateInfo: '已完结 · 共15集',
    isHot: true,
    isNew: false,
  },
  {
    id: 9,
    title: '孤注一掷',
    category: 'movie',
    subcategory: 'thriller',
    year: 2025,
    rating: 8.6,
    description: '程序员潘生和模特安娜被高薪招聘所吸引，出国淘金却意外落入境外诈骗工厂的陷阱。在经历了一系列惊心动魄的遭遇后，他们决定联手反击。影片以极具冲击力的写实手法揭露了网络诈骗的黑暗内幕，引发社会广泛关注。',
    image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20a%20man%20and%20woman%20looking%20fearful%20behind%20bars%2C%20dark%20underground%20room%20with%20computer%20screens%2C%20tense%20suspenseful%20atmosphere%2C%20gritty%20realistic%20style%2C%20film%20poster%20aesthetic&width=600&height=900&seq=movie-poster-003&orientation=portrait',
    tags: ['犯罪', '剧情', '社会', '真实改编'],
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君'],
    episodes: 1,
    updateInfo: '2025年暑期档上映',
    isHot: true,
    isNew: false,
  },
  {
    id: 10,
    title: '繁花',
    category: 'tv',
    subcategory: 'modern',
    year: 2025,
    rating: 9.1,
    description: '九十年代的上海，处处是机遇与挑战。阿宝凭借自己的智慧和努力，在商海中一步步打拼成为宝总。王家卫导演的首部电视剧作品，以独特的镜头语言和美学风格，描绘了一幅上海滩浮世绘，每个角色都鲜活而深刻。',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20drama%20poster%20with%20stylish%20man%20in%20vintage%20suit%20walking%20on%20neon-lit%20Bund%20street%2C%20retro%20Shanghai%20night%20scene%2C%20nostalgic%20elegant%20atmosphere%2C%20Wong%20Kar-wai%20inspired%20color%20palette%2C%20cinematic%20mood&width=600&height=900&seq=tv-poster-003&orientation=portrait',
    tags: ['都市', '商战', '年代', '文艺'],
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    episodes: 30,
    updateInfo: '已完结 · 共30集',
    isHot: true,
    isNew: false,
  },
  {
    id: 11,
    title: '脱口秀大会 第六季',
    category: 'variety',
    subcategory: 'talk',
    year: 2026,
    rating: 8.4,
    description: '国内最具影响力的脱口秀竞技节目重磅回归！来自各行各业的脱口秀演员用幽默犀利的语言，分享生活的酸甜苦辣。本季选手阵容空前强大，话题涵盖更广，笑点更加密集，是解压放松的不二之选。',
    image: 'https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20poster%20with%20a%20comedian%20on%20stage%20holding%20microphone%20under%20spotlight%2C%20laughing%20audience%20silhouettes%2C%20warm%20stage%20lighting%2C%20entertaining%20atmosphere%2C%20TV%20show%20promotional%20style&width=600&height=900&seq=variety-poster-003&orientation=portrait',
    tags: ['脱口秀', '搞笑', '语言', '竞技'],
    director: '谭晓虹',
    cast: ['李诞', '王建国', '庞博', '呼兰', '杨笠'],
    episodes: 10,
    updateInfo: '更新至第5期',
    isHot: false,
    isNew: true,
  },
  {
    id: 12,
    title: '哪吒之魔童闹海',
    category: 'anime',
    subcategory: 'chinese',
    year: 2026,
    rating: 9.5,
    description: '天劫之后，哪吒和敖丙虽然保住了灵魂，但肉身即将消散。太乙真人打算用七色宝莲为他们重塑肉身，然而过程中却遭遇了重重困难。哪吒将面临全新的挑战，在命运的洪流中寻找自己的道路。国产动画电影票房新纪录缔造者。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20animation%20poster%20with%20a%20young%20warrior%20boy%20with%20flaming%20hair%20riding%20wind%20fire%20wheels%2C%20dragon%20in%20stormy%20sky%2C%20epic%20fantasy%20battle%20scene%2C%20vibrant%20Chinese%20ink%20painting%20style%2C%20dynamic%20action%20composition&width=600&height=900&seq=anime-poster-003&orientation=portrait',
    tags: ['国漫', '神话', '动作', '奇幻'],
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    episodes: 1,
    updateInfo: '2026年暑期档热映中',
    isHot: true,
    isNew: true,
  },
  {
    id: 13,
    title: '封神第二部',
    category: 'movie',
    subcategory: 'action',
    year: 2026,
    rating: 8.9,
    description: '殷商末年，纣王暴虐无道。姜子牙携封神榜下山，辅佐西岐武王伐纣。神仙妖魔各显神通，一场惊天动地的封神大战就此展开。乌尔善导演倾力打造的神话史诗，以震撼的视觉特效和深厚的文化底蕴，重塑了中国人自己的神话宇宙。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20with%20ancient%20warriors%20and%20gods%20in%20celestial%20battle%2C%20thunder%20and%20lightning%20in%20sky%2C%20grand%20epic%20scale%2C%20dramatic%20cinematic%20lighting%2C%20film%20poster%20aesthetic%2C%20golden%20and%20crimson%20tones&width=600&height=900&seq=movie-poster-004&orientation=portrait',
    tags: ['神话', '史诗', '动作', 'IMAX'],
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    episodes: 1,
    updateInfo: '2026年春节档热映',
    isHot: true,
    isNew: true,
  },
  {
    id: 14,
    title: '庆余年 第二季',
    category: 'tv',
    subcategory: 'costume',
    year: 2026,
    rating: 9.0,
    description: '范闲从北齐归来后，发现了更多关于自己身世的秘密。朝堂之上暗流涌动，江湖之中风波再起。在权谋与武力的交织中，范闲一步步揭开迷雾，走向命运的对决。原班人马回归，剧情更加跌宕起伏。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20a%20handsome%20young%20man%20in%20elegant%20white%20ancient%20robe%20holding%20a%20sword%2C%20palace%20courtyard%20background%2C%20cherry%20blossoms%20falling%2C%20wuxia%20aesthetic%2C%20cinematic%20composition%2C%20soft%20dramatic%20lighting&width=600&height=900&seq=tv-poster-004&orientation=portrait',
    tags: ['古装', '权谋', '武侠', '热门'],
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    episodes: 36,
    updateInfo: '更新至第24集',
    isHot: true,
    isNew: true,
  },
  {
    id: 15,
    title: '向往的生活 第八季',
    category: 'variety',
    subcategory: 'reality',
    year: 2026,
    rating: 8.2,
    description: '远离城市喧嚣，回归田园生活。黄磊、何炅与嘉宾们一起在蘑菇屋中劳作、做饭、聊天，享受慢节奏的美好时光。本季蘑菇屋选址云南大理，苍山洱海间的诗意生活，治愈每一位观众的心灵。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20slow-living%20variety%20show%20poster%20with%20peaceful%20countryside%20farmhouse%20surrounded%20by%20green%20rice%20fields%20and%20mountains%2C%20warm%20sunset%20light%2C%20cozy%20rustic%20atmosphere%2C%20Dali%20Yunnan%20landscape%2C%20healing%20pastoral%20scene&width=600&height=900&seq=variety-poster-004&orientation=portrait',
    tags: ['慢综艺', '美食', '田园', '治愈'],
    director: '王征宇',
    cast: ['黄磊', '何炅', '彭昱畅', '张子枫', '张艺兴'],
    episodes: 14,
    updateInfo: '更新至第9期',
    isHot: false,
    isNew: true,
  },
  {
    id: 16,
    title: '间谍过家家 第二季',
    category: 'anime',
    subcategory: 'japanese_anime',
    year: 2025,
    rating: 9.1,
    description: '为了执行秘密任务，顶级间谍黄昏组建了一个临时家庭。女儿是会读心术的超能力者，妻子是杀手。三人各自隐瞒身份，却在相处中产生了真正的羁绊。温馨搞笑又治愈的家庭喜剧，每一集都让人捧腹又感动。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20a%20stylish%20family%20of%20three%20in%20formal%20attire%20posing%20elegantly%2C%20spy%20theme%20with%20hidden%20gadgets%2C%20clean%20modern%20anime%20art%20style%2C%20warm%20family%20vibe%20with%20action%20elements%2C%20bright%20and%20colorful&width=600&height=900&seq=anime-poster-004&orientation=portrait',
    tags: ['日漫', '喜剧', '治愈', '家庭'],
    director: '古桥一浩',
    cast: ['江口拓也', '种崎敦美', '早见沙织'],
    episodes: 25,
    updateInfo: '已完结 · 共25集',
    isHot: false,
    isNew: false,
  },
  {
    id: 17,
    title: '消失的她',
    category: 'movie',
    subcategory: 'thriller',
    year: 2025,
    rating: 8.5,
    description: '何非的妻子在海外旅行时神秘失踪，当他报案时，一个陌生女人却声称自己就是他的妻子。在追寻真相的过程中，何非发现了一个令人震惊的惊天秘密。层层反转的悬疑故事，让观众直到最后一刻才恍然大悟。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20with%20a%20woman%20silhouette%20disappearing%20into%20shadows%2C%20tropical%20island%20background%20at%20sunset%2C%20suspenseful%20atmosphere%2C%20film%20noir%20inspired%20composition%2C%20dark%20blue%20and%20orange%20color%20contrast&width=600&height=900&seq=movie-poster-005&orientation=portrait',
    tags: ['悬疑', '犯罪', '反转', '剧情'],
    director: '陈思诚',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    episodes: 1,
    updateInfo: '2025年暑期档上映',
    isHot: false,
    isNew: false,
  },
  {
    id: 18,
    title: '与凤行',
    category: 'tv',
    subcategory: 'costume',
    year: 2026,
    rating: 8.6,
    description: '魔界女将军沈璃因逃婚坠落凡间，被下凡历劫的仙界神君行止所救。两人在人间相伴相守，历经艰难险阻，最终联手对抗阴谋，守护三界和平。赵丽颖监制并主演，服化道精良，特效震撼。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20drama%20poster%20with%20a%20beautiful%20female%20warrior%20in%20flowing%20red%20robe%20flying%20through%20clouds%2C%20mythical%20phoenix%20in%20background%2C%20ethereal%20celestial%20palace%2C%20romantic%20fantasy%20aesthetic%2C%20soft%20magical%20glow&width=600&height=900&seq=tv-poster-005&orientation=portrait',
    tags: ['仙侠', '古装', '言情', '热门'],
    director: '邓科',
    cast: ['赵丽颖', '林更新', '辛云来', '何与'],
    episodes: 36,
    updateInfo: '更新至第18集',
    isHot: true,
    isNew: true,
  },
  {
    id: 19,
    title: '你好，星期六',
    category: 'variety',
    subcategory: 'game',
    year: 2026,
    rating: 8.0,
    description: '全新升级的周末合家欢综艺，每期邀请当红嘉宾参与趣味游戏挑战。爆笑的游戏环节加上走心的访谈内容，是周末放松的最佳选择。何炅领衔主持，每周六准时为观众带来欢乐。',
    image: 'https://readdy.ai/api/search-image?query=Weekend%20entertainment%20show%20poster%20with%20hosts%20and%20celebrities%20playing%20fun%20games%20on%20a%20colorful%20studio%20set%2C%20confetti%20and%20balloons%2C%20joyful%20party%20atmosphere%2C%20bright%20lighting%2C%20TV%20show%20promotional%20style&width=600&height=900&seq=variety-poster-005&orientation=portrait',
    tags: ['游戏', '搞笑', '访谈', '周末'],
    director: '刘乐',
    cast: ['何炅', '檀健次', '秦霄贤', '杨迪', '丁程鑫'],
    episodes: 52,
    updateInfo: '更新至第30期',
    isHot: false,
    isNew: false,
  },
  {
    id: 20,
    title: '一人之下 第五季',
    category: 'anime',
    subcategory: 'chinese',
    year: 2026,
    rating: 8.9,
    description: '张楚岚和冯宝宝在异人世界中继续探索身世之谜。罗天大醮之后，各方势力暗流涌动，一个更大的阴谋正在浮出水面。作为国产动画的标杆之作，本季战斗场面全面升级，剧情更加深沉有力。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20martial%20arts%20anime%20poster%20with%20characters%20using%20elemental%20powers%20in%20urban%20setting%2C%20dynamic%20action%20pose%2C%20energy%20effects%20and%20glowing%20auras%2C%20modern%20Chinese%20anime%20art%20style%2C%20intense%20battle%20atmosphere&width=600&height=900&seq=anime-poster-005&orientation=portrait',
    tags: ['国漫', '奇幻', '战斗', '悬疑'],
    director: '陈烨',
    cast: ['夏侯落枫', '小连杀', '藤新'],
    episodes: 12,
    updateInfo: '已完结 · 共12集',
    isHot: false,
    isNew: true,
  },
];

export const getMoviesByCategory = (category: string) =>
  movies.filter((m) => m.category === category);

export const getMoviesBySubcategory = (category: string, subcategory: string) =>
  movies.filter((m) => m.category === category && m.subcategory === subcategory);

export const getMovieById = (id: number) => movies.find((m) => m.id === id);

export const getHotMovies = () => movies.filter((m) => m.isHot);

export const getNewMovies = () => movies.filter((m) => m.isNew);

export const getRelatedMovies = (movie: MovieItem, count: number = 6) =>
  movies
    .filter((m) => m.id !== movie.id && m.category === movie.category)
    .slice(0, count);

export const categoryNames: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
  anime: '动漫',
};

export const subcategoryNames: Record<string, string> = {
  action: '动作片',
  comedy: '喜剧片',
  drama: '剧情片',
  scifi: '科幻片',
  horror: '恐怖片',
  romance: '爱情片',
  animation: '动画片',
  thriller: '悬疑片',
  domestic: '国产剧',
  korean: '韩剧',
  american: '美剧',
  japanese: '日剧',
  costume: '古装剧',
  modern: '现代剧',
  talk: '脱口秀',
  reality: '真人秀',
  music: '音乐综艺',
  game: '游戏竞技',
  dating: '恋爱综艺',
  chinese: '国漫',
  japanese_anime: '日漫',
  movie_anime: '动画电影',
  series: '连载动画',
};